import { Component } from '@angular/core';
import { InputComponent } from "../../../shared/components/forms/input/input.component";
import { SharedModule } from '@app/shared/shared.module';
import { TextComponent } from "../../../shared/components/forms/text/text.component";
import { Toaster } from '@app/services/toaster/toaster.service';
import { ContactService } from '../contact.service';
import { ContactApi } from '../contact.api';

@Component({
  selector: 'app-contact-form',
  standalone: true,
  imports: [
    SharedModule,
    InputComponent,
    TextComponent
	],
	providers: [
		ContactService,
		ContactApi,
	],
  templateUrl: './contact-form.component.html',
  styleUrl: './contact-form.component.scss'
})
export class ContactFormComponent {
	public loading:boolean = false;
	public name:string = "";
	public email:string = "";
	public message:string = "";
	public contactSent:boolean = false;

	constructor (
		private service: ContactService,
		private toast: Toaster,
	) { }

	public send() {
		this.loading = true;
		if(!this.validate()) {
			this.loading = false;
			return;
		}
		this.service.sendContact(
			this.name, this.email, this.message
		).subscribe({
			next: (rs) => {
				this.toast.success("Mensagem enviada!");
				this.contactSent = true;
				this.loading = false;
			},
			error: (err) => {
				console.error(err);
				this.loading = false;
			}
		})
	}

	public validate(): boolean {
		let valid:boolean = true;
		if(!this.name) {
			this.toast.error("Preencha o nome!");
			valid = false;
		}
		if(!this.email) {
			this.toast.error("Preencha um e-mail de contato!");
			valid = false;
		}
		if(!this.message) {
			this.toast.error("Se você não tem nada a dizer, é melhor não dizer nada.");
			valid = false;
		}
		return valid;
	}


}
